const state = {
  all: [],
  buildingRooms:[]
}

const getters = {}

const actions = {
  getRooms ({ commit }, params) {
    axios
      .get("/admin/buildings/"+params.building_id+'/floors/'+params.floor_id+"/rooms")
      .then(response => (commit('setData', response.data)));
  },
  addRoom ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/admin/buildings/"+params.building_id+'/floors/'+params.floor_id+"/rooms", params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  editRoom ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .put("/admin/buildings/"+params.building_id+'/floors/'+params.floor_id+"/rooms/"+params.room_id, params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },

  getBuildingRooms ({ commit }, params) {
    axios
      .get("/admin/rooms/buildingRooms", {params: params})
      .then(response => (commit('setBuildingRooms', response.data)));
  },
}

const mutations = {
  setData (state, data) {
    state.all = data.data;
  },
  setBuildingRooms (state, data) {
    state.buildingRooms = data.data;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
